'use strict';

function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://vimeo.com/';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional vimeo url formats
  var vimeoUrlRegex = /vimeo\.com\/(\d+)$/gi;
  var match = vimeoUrlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/videoUrlsUtils/vimeoVideoUtils.js